import { type TransactionHash, TRANSACTION_TYPES, EVENT_SUFFIXES } from "@/types";
import { createEventEmitter } from "@/events";

export const REALLOCATE_POINTS_EVENTS = {
    SUCCESS: `${TRANSACTION_TYPES.REALLOCATE_POINTS}:${EVENT_SUFFIXES.SUCCESS}`,
} as const;

export interface ReallocatePointsSuccessPayload {
    newAddress: string;
    transactionHash: TransactionHash;
}

export interface ReallocatePointsEventPayloads extends Record<string, unknown> {
    [REALLOCATE_POINTS_EVENTS.SUCCESS]: ReallocatePointsSuccessPayload;
}

export const reallocatePointsEventEmitter = createEventEmitter<ReallocatePointsEventPayloads>();
